var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Catalog",
    _vm._g(
      {
        attrs: {
          title: "Тег",
          "name-label": "Название тега",
          "submit-error": "Укажите название тега.",
          "fetch-data": _vm.fetchData,
          "put-data": _vm.putData,
          "post-data": _vm.postData
        },
        scopedSlots: _vm._u([
          {
            key: "optional-skeleton",
            fn: function() {
              return [
                _c(
                  "b-row",
                  { staticClass: "mb-2" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "8" } },
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-2",
                          attrs: { width: "32%", height: "20%" }
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          attrs: { type: "input", width: "100%", height: "43%" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "4" } },
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-2",
                          attrs: { width: "16%", height: "20%" }
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          attrs: { type: "input", width: "100%", height: "43%" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "optional-fields",
            fn: function(ref) {
              var model = ref.model
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "group-description",
                              label: "Описание"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "input-description",
                                type: "text",
                                size: "sm",
                                trim: ""
                              },
                              model: {
                                value: model.description,
                                callback: function($$v) {
                                  _vm.$set(model, "description", $$v)
                                },
                                expression: "model.description"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-354cac09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-354cac09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/RecruitTags/RecruitTag.vue
// module id = null
// module chunks = 